import { useState } from 'react';
import { Button } from '../../../components/UI-CHAKRA/Button';
import { IconButton } from '../../../components/UI-CHAKRA/IconButton';
import { useIsMobile } from '../../../helpers/useIsMobile';
import { SelectModelDrawer } from './SelectModelDrawer';

function MedicalDataClipboardCrossIcon({ size = 16 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox={'0 0 16 16'}
      fill={'none'}
      xmlns={'http://www.w3.org/2000/svg'}
      aria-hidden={true}
    >
      <path
        d={
          'M12.9301 8.59644H10.5601V10.6094H8.54724V12.9795H10.5601V14.9924H12.9301V12.9795H14.9429V10.6094H12.9301V8.59644Z'
        }
        stroke={'currentColor'}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
      />
      <path
        d={'M3.39844 6.16925H9.40403'}
        stroke={'currentColor'}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
      />
      <path
        d={'M3.39844 8.98187H7.68816'}
        stroke={'currentColor'}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
      />
      <path
        d={'M3.39844 11.7945H5.54329'}
        stroke={'currentColor'}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
      />
      <path
        d={
          'M8.33541 14.9032H2.12592C1.84246 14.9032 1.57061 14.7907 1.37017 14.5902C1.16973 14.3898 1.05713 14.1179 1.05713 13.8344V3.14599C1.05713 2.86252 1.16973 2.59065 1.37017 2.3902C1.57061 2.18975 1.84246 2.07715 2.12592 2.07715H3.72911'
        }
        stroke={'currentColor'}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
      />
      <path
        d={
          'M8.00419 1.00842H4.7978C4.20752 1.00842 3.729 1.48694 3.729 2.07721V2.61161C3.729 3.20189 4.20752 3.6804 4.7978 3.6804H8.00419C8.59444 3.6804 9.07294 3.20189 9.07294 2.61161V2.07721C9.07294 1.48694 8.59444 1.00842 8.00419 1.00842Z'
        }
        stroke={'currentColor'}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
      />
      <path
        d={
          'M9.07312 2.07715H10.6763C10.9598 2.07715 11.2316 2.18975 11.4321 2.39019C11.6325 2.59062 11.7451 2.86248 11.7451 3.14594V6.97112'
        }
        stroke={'currentColor'}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
      />
    </svg>
  );
}

export function OpenModelsButton() {
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useIsMobile();

  const baseProps = {
    onClick: () => setIsOpen(true),
    bg: 'white',
    color: 'primary.main',
    borderColor: 'primary.main',
    borderWidth: '1.5px',
    flexShrink: 0,
    'data-testid': 'adicionar-modelo-button',
  };

  return (
    <>
      {isMobile ? (
        <IconButton
          {...baseProps}
          variant={'outline'}
          aria-label={'Ver modelos'}
          icon={<MedicalDataClipboardCrossIcon size={18} />}
          h={'40px'}
          w={'40px'}
          minW={'40px'}
          borderRadius={'8px'}
        />
      ) : (
        <Button
          {...baseProps}
          variant={'outline'}
          leftIcon={<MedicalDataClipboardCrossIcon size={16} />}
          h={'40px'}
          px={'12px'}
          py={'12px'}
          borderRadius={'40px'}
          fontSize={'14px'}
          fontWeight={700}
        >
          Ver modelos
        </Button>
      )}

      <SelectModelDrawer isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
}
